import { url } from "./config";

export var logo: string = '';
export var logoDasboard: string = '';

try {
  //console.log();

  let datos = JSON.parse(localStorage.getItem('calidad_user_tag_1'));
  let nombre: string = datos.name;
  if (nombre.localeCompare('Locatec') == 0) {

    logo = url + "upload/resources/locatec-mini.png";
    logoDasboard = url + "upload/resources/logo.jpg";
  } else {
    logo = url + "upload/resources/locatec-mini.png";
    logoDasboard = url + "upload/resources/logo.jpg";
  }
} catch (error) {
  logo = url + "upload/resources/locatec-mini.png";
  logoDasboard = url + "upload/resources/logo.jpg";
}
//export var logo: string=url+"upload/resources/logo-brio.png";
export var logoLogin: string = url + "upload/resources/Logo Brio.png";
export var check: string = url + "upload/resources/mark.png";
export var cancel: string = url + "upload/resources/cancel.png";
export var logoLocatec: string = url + "upload/resources/logo.jpg";